import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { BackupState } from '../../reducers/backups';

export const getShopifyActionsSelector = createSelector((state: DefaultRootState) => state.backups, ({shopify}: BackupState) => shopify.actions);
export const getShopifyActionsTotalSelector = createSelector((state: DefaultRootState) => state.backups, ({shopify}: BackupState) => shopify.totalActions);
export const isShopifyActionsLoadingSelector = createSelector((state: DefaultRootState) => state.backups, ({shopify}: BackupState) => shopify.loading);
export const getShopifyCanRestore = createSelector((state: DefaultRootState) => state.backups, ({shopify}: BackupState) => shopify.canRestore);
